import { useSearch } from "@tanstack/react-router";
import { DetailCommissionDrawer } from "components/Drawers/DetailCommissionDrawer/DetailCommissionDrawer.tsx";
import { OfferGeneralEditForm } from "components/Forms/OfferGeneralEditForm/OfferGeneralEditForm.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { useUser } from "hooks/useUser.ts";
import { PermissionEnum, RoleEnum } from "types/enums.ts";
import { DrawerId, FormId } from "types/models.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getOfferEditHeaderItems } from "utils/tenantHeaderItems.ts";
export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/offer/_layout/edit/$offerId/_layout/general/"
)({
    component: OfferGeneralEditPage,
    staticData: {
        permissions: [PermissionEnum.OfferEditDefault],
        showInSideMenu: false,
        label: "pages.offer.edit.general.title",
    },
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.offer.edit.general.title"),
    }),
});

interface SearchParams {
    [`editCommission-id`]: string;
    [`detailCommission-id`]: string;
}

function OfferGeneralEditPage() {
    const { offerId } = Route.useParams();
    const userUtils = useUser();
    const searchParams = useSearch({ strict: false }) as SearchParams;
    const { t } = usePaldockTranslation("pages.offer.edit");

    return (
        <TenantPage
            headerNavigationItems={getOfferEditHeaderItems}
            saveFormId={
                userUtils
                    ?.getActiveTenant()
                    ?.userRoles?.some((role) => [RoleEnum.AdminFree, RoleEnum.AdminBeast].includes(role.name))
                    ? FormId.OfferGeneralEditForm
                    : null
            }
            isEdit={true}
            detailLink={
                userUtils
                    ?.getActiveTenant()
                    ?.userRoles?.some((role) => [RoleEnum.AdminFree, RoleEnum.AdminBeast].includes(role.name))
                    ? {
                          to: "/offer/detail/$offerId/link",
                          params: { offerId: offerId },
                          label: t("offer_preview"),
                      }
                    : null
            }
        >
            <OfferGeneralEditForm key={offerId} offerId={offerId} />
            {searchParams[`${DrawerId.DetailCommission}-id`] && (
                <DetailCommissionDrawer commissionId={searchParams[`${DrawerId.DetailCommission}-id`]} />
            )}
        </TenantPage>
    );
}
